import { cloneDeep } from "lodash";
import {
  ADD_CONNECTION_VALUE_ERROR,
  ADD_CONNECTION_VALUE_STARTING,
  ADD_CONNECTION_VALUE_SUCCESS,
} from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function addConnectionValueReducer(
  state = initialState.addConnectionValue,
  action
) {
  switch (action.type) {
    case ADD_CONNECTION_VALUE_STARTING: {
      const newState = cloneDeep(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_CONNECTION_VALUE_SUCCESS: {
      const { data } = action;
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newConnectionValue = data.connectionValues;
      return newState;
    }

    case ADD_CONNECTION_VALUE_ERROR: {
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
